module.exports = __webpack_public_path__ + "static/media/c12_3.b663a47c.png";